<!-- 新闻 -->
<template>
  <div class="wrap">
    <div class="header">
      <img
        src="@/assets/return.png"
        class="return-img"
        @click="$router.back()"
        alt=""
      />
      <p class="header-title">新闻</p>
    </div>

    <ul class="tab-list">
      <li @click="$router.push('/news-comment-on-my')">
        <div class="tab-item-box">
          <img src="@/assets/message@2x.png" class="tab-item-icon" alt="" />
          <badge-num
            class="tab-item-num"
            :num="markNum.comment_num"
            :max="99"
            v-if="markNum.comment_num && markNum.comment_num > 0"
          />
        </div>
        评论我的
      </li>
      <li @click="$router.push('/news-reply-to-me')">
        <div class="tab-item-box">
          <img src="@/assets/icon-164.png" class="tab-item-icon" alt="" />
          <badge-num
            class="tab-item-num"
            :num="markNum.reply_num"
            :max="99"
            v-if="markNum.reply_num && markNum.reply_num > 0"
          />
        </div>
        回复我的
      </li>
      <li @click="$router.push('/news-like-me')">
        <div class="tab-item-box">
          <img src="@/assets/icon-165.png" class="tab-item-icon" alt="" />
          <badge-num
            type="dian"
            class="tab-item-num"
            :num="markNum.praise_num"
            :max="99"
            v-if="markNum.praise_num && markNum.praise_num > 0"
          />
        </div>
        点赞我的
      </li>
    </ul>

    <ul class="list">
      <li @click="$router.push('/news-my-comments')">
        <img src="@/assets/icon-157.png" class="item-icon" alt="" />
        <div class="item-sidebar">
          <span class="item-name">我的评论</span>
          <img src="@/assets/back-icon.png" class="back-icon" alt="" />
        </div>
      </li>
      <li @click="$router.push('/news-my-reply')">
        <img src="@/assets/icon-158.png" class="item-icon" alt="" />
        <div class="item-sidebar">
          <span class="item-name">我的回复</span>
          <img src="@/assets/back-icon.png" class="back-icon" alt="" />
        </div>
      </li>
    </ul>

    <ul class="list">
      <li @click="$router.push('/news-my-likes')">
        <img src="@/assets/icon-159.png" class="item-icon" alt="" />
        <div class="item-sidebar">
          <span class="item-name">我的点赞</span>
          <img src="@/assets/back-icon.png" class="back-icon" alt="" />
        </div>
      </li>
      <li @click="$router.push('/news-my-collection')">
        <img src="@/assets/icon-160.png" class="item-icon" alt="" />
        <div class="item-sidebar">
          <span class="item-name">我的收藏</span>
          <img src="@/assets/back-icon.png" class="back-icon" alt="" />
        </div>
      </li>
    </ul>

    <ul class="list">
      <li @click="$router.push('/news-my-release')">
        <img src="@/assets/icon-161.png" class="item-icon" alt="" />
        <div class="item-sidebar">
          <span class="item-name">我的发布</span>
          <img src="@/assets/back-icon.png" class="back-icon" alt="" />
        </div>
      </li>
      <li @click="$router.push('/news-history')">
        <img src="@/assets/icon-162.png" class="item-icon" alt="" />
        <div class="item-sidebar">
          <span class="item-name">浏览记录</span>
          <img src="@/assets/back-icon.png" class="back-icon" alt="" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { PressService } from "@/common/service";
import BadgeNum from "@/components/badge-num.vue";

export default {
  components: { BadgeNum },
  data() {
    return {
      markNum: {
        reply_num: 0, // 回复我的
        comment_num: 0, // 评论我的
        praise_num: 0, // 点赞我的【包含新闻点赞和评论点赞】
        praise_press: 0, // 点赞我的--新闻
        praise_comment: 0, //	点赞我的--评论
      },
    };
  },
  mounted() {
    this.getMarkNum();
  },
  methods: {
    getMarkNum() {
      PressService.getMarkNum().then(({ data }) => {
        this.markNum = data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  width: 100%;
  min-height: calc(var(--vh) * 100);
  background: url(../../assets/bg-23.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding-top: 44px;
  box-sizing: border-box;
  /* 头部样式 */
  .header {
    width: 100%;
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    background: url(../../assets/bg-19.png) no-repeat;
    background-size: 100% auto;
    z-index: 999;
    overflow: hidden;
    .return-img {
      position: absolute;
      left: 15px;
      top: 50%;
      transform: translate(0, -50%);
      width: 20px;
    }
    .header-title {
      color: #333333;
      font-size: 18px;
      font-weight: bold;
    }
  }
  .tab-list {
    width: calc(100% - 24px);
    height: 124px;
    display: flex;
    align-items: center;
    background-color: #ffffff;
    border-radius: 10px;
    margin: 10px auto;
    li {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #222222;
      font-size: 13px;
      .tab-item-box {
        margin-bottom: 12px;
        position: relative;
      }

      .tab-item-icon {
        width: 44px;
        height: 44px;
      }

      .tab-item-num {
        background-color: #ff5143;
        min-width: 13px;
        height: 13px;
        line-height: 13px;
        padding: 0 3px;
        box-sizing: border-box;
        position: absolute;
        right: 0;
        top: 0;
        color: #ffffff;
        font-size: 10px;
        border: 1px solid #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  .list {
    width: calc(100% - 24px);
    display: flex;
    flex-direction: column;
    padding: 0 10px 0 14px;
    box-sizing: border-box;
    margin: 0 auto 10px;
    background-color: #ffffff;
    border-radius: 10px;
    li {
      width: 100%;
      height: 76px;
      display: flex;
      align-items: center;
      position: relative;
      .item-icon {
        width: 44px;
        margin-right: 12px;
      }
      .item-sidebar {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        .item-name {
          flex: 1;
          color: #222222;
          font-size: 15px;
        }
        .back-icon {
          width: 7px;
        }
      }
    }
    li::after {
      position: absolute;
      content: "";
      width: 271px;
      height: 1px;
      background-color: #f4f4f4;
      bottom: 0;
      right: 0;
    }
  }
}
</style>
